import React from 'react';

function Calendar() {
  /* eslint-disable max-len */
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path d="M20.2 2.4H19V0h-2.4v2.4H7V0H4.6v2.4H3.4c-1.332 0-2.388 1.08-2.388 2.4L1 21.6C1 22.92 2.068 24 3.4 24h16.8c1.32 0 2.4-1.08 2.4-2.4V4.8c0-1.32-1.08-2.4-2.4-2.4zm0 19.2H3.4V8.4h16.8v13.2zM5.8 10.8h6v6h-6v-6z" />
    </svg>
  );
  /* eslint-enable */
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/common/icons/Calendar.js